import React, { Fragment } from 'react';
import {
    TopContainer, Area, TopText, RedText, CTAButton, FlexRow, FlexColumn,
    UmbrellaIcon, DescriptionText,
} from './index.style';

const Top = ({ setFormActive, top: { titleBlue, titleRed, cta, description } }) => (<Fragment>
    <TopContainer>
        <Area>
            <FlexRow>
                <FlexColumn>
                    {!!titleBlue &&
                        <TopText>
                            {titleBlue.text}
                            {!!titleRed &&
                                <RedText>{titleRed.text}</RedText>}
                        </TopText>}
                    {!!cta &&
                        <CTAButton onClick={() => setFormActive(true)}>{cta.text}</CTAButton>}
                </FlexColumn>
            </FlexRow>
        </Area>
    </TopContainer>
    <Area>
        <FlexColumn>
            <UmbrellaIcon />
            {!!description &&
                <DescriptionText>{description.text}</DescriptionText>}
        </FlexColumn>
    </Area>
</Fragment>);

export default Top;